import { createSelector } from 'reselect';
import { getSensorFeature } from '../helpers';
import { sensorFeatureKeys } from '../../../constants';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import { apiCallStatus } from 'helpers/constants';

const getLoadingStatuses = ({ operationalParameters, sensorProperties }) => {
    return [operationalParameters?.loadMeasurementLoadingStatus,
    operationalParameters?.sensorLastCommand?.loadingStatus,
    sensorProperties?.sensorProperties?.loadingStatus,
    sensorProperties?.sensorFeatures?.loadingStatus];
    // return [operationalParameters.loadMeasurementLoadingStatus, operationalParameters.sensorLastCommand?.loadingStatus];
};

const getOnDemandDataCollectionRequestFeature = ({ sensorProperties }) => {
    return getSensorFeature(sensorProperties?.sensorFeatures?.data, sensorFeatureKeys.OnDemandDataCollectionRequest);
};

const getOnDemandDataCollectionResponseMessageFeature = ({ sensorProperties }) => {
    return getSensorFeature(sensorProperties?.sensorFeatures?.data, sensorFeatureKeys.OnDemandDataCollectionResponseMessage);
};

const getOnDemandDataCollectionData = ({ operationalParameters }) => {
    return operationalParameters?.sensorLastCommand?.data;
};

const getSensorGatewayInfoOP = ({ sensorProperties }) => {
    return sensorProperties?.sensorGatewayInfo;
};

const getRawSensorLastCommandError = ({ operationalParameters }) => {
    if (operationalParameters?.sensorLastCommand?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.sensorLastCommand.loadingStatus,
            error: operationalParameters.sensorLastCommand.error,
            errorCode: operationalParameters.sensorLastCommand.error?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.sensorLastCommand?.loadingStatus };
};

const getSensorLastCommandErrorData = createErrorDataSelector(getRawSensorLastCommandError);

const getRawLoadMeasurementError = ({ operationalParameters }) => {
    if (operationalParameters?.loadMeasurementLoadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.loadMeasurementLoadingStatus,
            error: operationalParameters.loadMeasurementError,
            errorCode: operationalParameters.loadMeasurementError?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.loadMeasurementLoadingStatus };
};

const getLoadMeasurementErrorData = createErrorDataSelector(getRawLoadMeasurementError);

export const getModel = createSelector([
    getLoadingStatuses,
    getOnDemandDataCollectionRequestFeature,
    getOnDemandDataCollectionResponseMessageFeature,
    getOnDemandDataCollectionData,
    getSensorGatewayInfoOP,
    getSensorLastCommandErrorData,
    getLoadMeasurementErrorData,
],
    (
        loadingStatuses,
        onDemandDataCollectionRequest,
        onDemandDataCollectionResponseMessage,
        onDemandDataCollectionData,
        sensorGatewayInfo,
        errorData,
        loadMeasurementErrorData,
    ) => {
        return {
            loadingStatuses,
            onDemandDataCollectionRequest,
            onDemandDataCollectionResponseMessage,
            onDemandDataCollectionData,
            sensorGatewayInfo,
            errorData,
            loadMeasurementErrorData,
        };
    });
